import { track as amplitudeTrack } from '@amplitude/analytics-browser';

type BaseEventProperties = {
  appName: 'highlighter-app' | 'customer-app';
};

type ValidateEventMap<T extends Record<string, BaseEventProperties>> = T;

type EventMap = ValidateEventMap<{
  highlighter_account_activated: BaseEventProperties & {
    highlighter_id: string;
    account_status: string;
  };
  highlighter_participation_agreement_signed: BaseEventProperties & {
    highlighter_id: string;
  };
  highlighter_login_initiated: BaseEventProperties & {
    auth_method: 'google' | 'magic_link';
  };
}>;

export const Analytics = {
  track<E extends keyof EventMap>(event: E, properties: EventMap[E]): void {
    const isGpcOptOut =
      typeof navigator !== 'undefined' && (navigator as any).globalPrivacyControl === true;

    // Highlighter can also set an explicit opt-out flag based on request headers.
    const globalFlagOptOut = (globalThis as any).__HIGHLIGHT_GPC_OPTOUT__ === true;

    if (isGpcOptOut || globalFlagOptOut) {
      if (process.env.NODE_ENV !== 'production') {
        console.log('[Analytics] Suppressed by GPC opt-out', event);
      }
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      console.log('[Analytics]', event, properties);
      return;
    }

    amplitudeTrack(event, properties as unknown as Record<string, unknown>);
  },
};
